var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowercaseThinaerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 223.9 57.7",
    style: {
      enableBackground: "new 0 0 223.9 57.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:current;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,5.2v9.7h8.7v7.5H20v17.4c0,3.2,1.7,4.7,4.6,4.7h4.1V52h-5.4C15.9,52,11,47.8,11,40.2V22.4H4.7v-7.5H11V5.2 H20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,5.2h9v18.7c1.9-3.2,5.4-5.1,10-5.1c7.3,0,12.1,5.3,12.1,12.8V52h-9V33.7c0-4-2.6-6.8-6.4-6.8 c-4,0-6.7,3-6.7,7.3V52h-9V5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.8,5.2v9.5h-9.6V5.2H81.8z M72.5,19.4h9.1V52h-9.1V19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.5,19.4h9.1v4.5c1.8-3.2,5.4-5.1,9.9-5.1c7.4,0,12.2,5.3,12.2,12.8V52h-9.1V33.7c0-4-2.5-6.8-6.3-6.8 c-4,0-6.7,3-6.7,7.3V52h-9.1V19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.5,35.7c0-10.2,5.8-16.8,15.3-16.8c4,0,7.2,1.5,9,3.8v-3.2h9.1V52h-9.1v-3.4c-1.6,2.4-5.1,4-8.9,4 C129.3,52.5,123.5,45.9,123.5,35.7z M148.4,35.7c0-5.5-3.2-9.1-8-9.1c-4.8,0-8,3.6-8,9.1c0,5.4,3.2,9.1,8,9.1 C145.2,44.8,148.4,41.1,148.4,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194,40.9c-1.3,7.1-7.5,11.6-15.6,11.6c-11.1,0-16.8-8.7-16.8-16.9c0-8.3,5.1-16.8,16.1-16.8 c11.5,0,16.1,8.5,16.1,15.9c0,1.2-0.1,2.2-0.1,2.9h-23.5c0.6,4.6,3.6,7.5,8.1,7.5c3.6,0,6-1.4,6.7-4.2H194z M170.5,32h14.5 c-0.3-3.6-2.8-6.5-7.1-6.5C173.7,25.5,171.3,27.5,170.5,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.8,26.9c-4.5,0-6.5,3.7-6.5,9.3V52h-9.1V19.4h9.1v5.4c1.8-4.1,4.2-5.4,8.2-5.4h3.7v7.5H213.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowercaseThinaerLogo);
export default __webpack_public_path__ + "static/media/lowercase-thinaer-logo.65e0a170.svg";
export { ForwardRef as ReactComponent };